var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.971 4.232V2.139a.371.371 0 0 0-.637-.262l-2.85 2.842a.371.371 0 0 0 0 .533l2.842 2.842a.38.38 0 0 0 .645-.27V5.732a4.502 4.502 0 0 1 4.396 5.467 4.47 4.47 0 0 1-3.428 3.428 4.51 4.51 0 0 1-5.423-3.758.75.75 0 0 0-1.485.21 6.01 6.01 0 0 0 7.148 5.04 5.984 5.984 0 0 0 4.68-4.68 6.013 6.013 0 0 0-5.888-7.207z",
    fill: "#4318ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestart);
export default __webpack_public_path__ + "static/media/restart.e5c5359ae7dcebdab29712d18685f9c6.svg";
export { ForwardRef as ReactComponent };